module.exports = __webpack_public_path__ + "static/media/mapa_tatico.9894b0db.png";